export default {
  'entityBuilder.title': 'Entity Builder',
  'entityBuilder.back': 'Back',
  'entityBuilder.canvas': 'Canvas',
  'entityBuilder.data': 'Data',
  'entityBuilder.publish': 'Publish',
  'entityBuilder.publish.success': 'Entity published successfully',
  'entityBuilder.publish.error': 'Error publishing',
  'entityBuilder.error.notFound': 'Entity not found or does not exist',
  'entityBuilder.published': 'Published',
  'entityBuilder.settings': 'Settings',
  'entityBuilder.more': 'More options',

  'entityBuilder.stats.fields': 'Fields',
  'entityBuilder.stats.required': 'Required',
  'entityBuilder.stats.optional': 'Optional',
  'entityBuilder.col.field': 'Field',
  'entityBuilder.col.type': 'Type',
  'entityBuilder.badge.req': 'REQ',
  'entityBuilder.field.add': 'Add',
  'entityBuilder.field.edit': 'Edit field',
  'entityBuilder.field.delete': 'Delete field',
  'entityBuilder.field.delete.confirm': 'Are you sure you want to delete this field?',
  'entityBuilder.field.required': 'Required',
  'entityBuilder.field.showMore': 'Show more',
  'entityBuilder.field.showLess': 'Show less',

  'entityBuilder.addField.title': 'Select field type',
  'entityBuilder.addField.search': 'Search type...',

  'entityBuilder.panel.settings': 'General Settings',
  'entityBuilder.panel.fieldEditor': 'Edit Field',
  'entityBuilder.panel.tokens': 'API Tokens',
  'entityBuilder.panel.collaborators': 'Collaborators',
  'entityBuilder.panel.lists': 'Lists',
  'entityBuilder.panel.traces': 'History',
  'entityBuilder.panel.tasks': 'Tasks',
  'entityBuilder.panel.data': 'Import / Export',
  'entityBuilder.panel.relations': 'Relations',

  'entityBuilder.tokens.add': 'Add Token',
  'entityBuilder.tokens.name': 'Name',
  'entityBuilder.tokens.readEnabled': 'Read',
  'entityBuilder.tokens.writeEnabled': 'Write',
  'entityBuilder.tokens.deleteEnabled': 'Delete',
  'entityBuilder.tokens.copy': 'Copy token',
  'entityBuilder.tokens.view': 'View details',
  'entityBuilder.tokens.copied': 'Token copied to clipboard',
  'entityBuilder.tokens.delete.confirm': 'Are you sure you want to delete this token?',
  'entityBuilder.tokens.noPerms': 'No permissions',
  'entityBuilder.tokens.empty': 'No tokens',
  'entityBuilder.tokens.empty.hint':
    'Create API tokens to integrate this entity with external systems',

  'entityBuilder.collaborators.title': 'Collaborators',
  'entityBuilder.collaborators.addSection': 'Add collaborators',
  'entityBuilder.collaborators.selectUsers': 'Select users',
  'entityBuilder.collaborators.usersRequired': 'Select at least one user',
  'entityBuilder.collaborators.add': 'Add Collaborator',
  'entityBuilder.collaborators.current': 'Current collaborators',
  'entityBuilder.collaborators.remove.confirm': 'Remove collaborator?',
  'entityBuilder.collaborators.remove.content': 'Are you sure you want to remove {userName}?',
  'entityBuilder.collaborators.empty': 'No collaborators in this entity',

  'entityBuilder.data.import': 'Import',
  'entityBuilder.data.export': 'Export',
  'entityBuilder.data.purge': 'Purge data',
  'entityBuilder.data.purge.confirm': 'Type PURGE to confirm',
  'entityBuilder.data.deleteExisting': 'Delete existing data on import',

  'entityBuilder.purge.title': 'Clear entity data',
  'entityBuilder.purge.warning':
    'This action will permanently delete all records for this entity. It cannot be undone.',
  'entityBuilder.purge.instruction': 'To confirm, type "{name}"',
  'entityBuilder.purge.mismatch': 'The name does not match the entity name',
  'entityBuilder.purge.confirm': 'Clear data',

  'entityBuilder.relations.dependencies': 'Dependencies',
  'entityBuilder.relations.dependents': 'Dependents',
  'entityBuilder.relations.current': 'Current entity',
  'entityBuilder.relations.empty': 'No relations',
  'entityBuilder.relations.empty.hint':
    'Relations will appear here when you configure reference fields between entities',

  'entityBuilder.relations.type.entityField': 'Field',
  'entityBuilder.relations.type.formField': 'Form',
  'entityBuilder.relations.type.action': 'Action',
  'entityBuilder.relations.type.listField': 'List',
  'entityBuilder.relations.type.process': 'Process',

  'entityBuilder.relations.sourceType.entity': 'Entity',
  'entityBuilder.relations.sourceType.process': 'Process',
  'entityBuilder.relations.fieldFrom': 'From {name}',
  'entityBuilder.relations.fieldTo': 'In {name}',
  'entityBuilder.relations.depTitle': 'Depends on',
  'entityBuilder.relations.depndtTitle': 'Depend on me',

  'entityBuilder.canvas.fit': 'Fit to canvas',
  'entityBuilder.canvas.fullscreen': 'Fullscreen',
  'entityBuilder.canvas.exitFullscreen': 'Exit fullscreen',
  'entityBuilder.canvas.zoomIn': 'Zoom in',
  'entityBuilder.canvas.zoomOut': 'Zoom out',

  'entityBuilder.canvas.empty': 'Your entity starts here',
  'entityBuilder.canvas.empty.description':
    'Add fields to define the structure of your dynamic entity',
  'entityBuilder.canvas.empty.hint': 'Click on "+ New column" to start',

  'entityBuilder.version.number': 'Version',
  'entityBuilder.version.status': 'Status',
  'entityBuilder.version.published': 'Published',
  'entityBuilder.version.draft': 'Draft',
  'entityBuilder.version.createdBy': 'Created by',
  'entityBuilder.version.createdDate': 'Created date',
  'entityBuilder.version.publishedBy': 'Published by',
  'entityBuilder.version.publishedDate': 'Published date',
  'entityBuilder.version.error': 'Error switching version',
  'entityBuilder.header.purge': 'Clean data',
  'entityBuilder.chat.error': 'Could not initialize chat',
  'entityBuilder.chat.noConnection': 'No connection. Try again.',
  'entityBuilder.chat.title': 'AI Assistant',
  'entityBuilder.chat.open': 'Open chat',
  'entityBuilder.chat.close': 'Close chat',
};
